import * as $script from 'loadjs';

import { HEADER_HEIGHT, OVERLAY_SDK_LOCATION } from './constants';
import { getEnvDependentEndpoint } from '@sitegen/common/utils/ubi-services';
import { IGetProfilesResponse } from 'modules/ubisoft-connect-service/types';
import {
    IUbiOverlayServiceConfig,
    IUbiOverlayWidget,
    IUbiOverlayWidgetConfig,
    IWindowWithOverlay
} from 'modules/ubisoft-overlay-service/types';

function getOverlaySDKEndpoint(envName: string) {
    return getEnvDependentEndpoint({ envName, source: OVERLAY_SDK_LOCATION });
}

export class UbisoftOverlayService {
    private initializedOnce: boolean;
    private overlaySDK: IUbiOverlayWidget;
    private config: IUbiOverlayWidgetConfig;
    private loginCallback: () => void | undefined;
    private logoutCallback: () => void | undefined;

    public init(containerSelector: string) {
        this.overlaySDK = (window as IWindowWithOverlay).overlayWidget;

        if (!this.overlaySDK.hasInitialized && !this.initializedOnce) {
            this.initializedOnce = true;
            this.overlaySDK.init({
                ...this.config,
                container: containerSelector
            });
        }
    }

    public configure(config: IUbiOverlayServiceConfig) {
        this.config = {
            appId: config.appId,
            genomeId: config.genomeId,
            locale: config.locale,
            loginType: 'modal',
            height: HEADER_HEIGHT,
            showSignInText: 'DEFAULT',
            thirdPartyCookiesSupport: false,
            onConnect: (action: string, getSession: IGetProfilesResponse) => {
                if (action === 'logout') {
                    this.logoutCallback();
                }
                if (getSession.status === 'ok') {
                    this.logIn();
                }
            }
        };
    }

    public reInit() {
        if (this.overlaySDK) {
            this.overlaySDK.reInit();
        }
    }

    public logIn() {
        if (this.loginCallback) {
            this.loginCallback();
        }
    }

    public logOut() {
        if (this.logoutCallback) {
            this.logoutCallback();
        }
    }

    public registerLoginCallback(loginCallback: () => void) {
        this.loginCallback = loginCallback;
    }

    public registerLogoutCallback(logoutCallback: () => void) {
        this.logoutCallback = logoutCallback;
    }

    public static changeLocale(locale: string) {
        if ((window as IWindowWithOverlay).overlayWidget && (window as IWindowWithOverlay).overlayWidget.hasInitialized) {
            (window as IWindowWithOverlay).overlayWidget.changeLocale(locale);
        }
    }

    public static loadSDKScript(envName: string): Promise<void> {
        return new Promise<void>(resolve => {
            if ((window as IWindowWithOverlay).overlayWidget) {
                return resolve();
            }

            const scriptId = 'overlaySDK';
            const scriptUrl = getOverlaySDKEndpoint(envName);

            $script(scriptUrl, scriptId);
            $script.ready(scriptId, function () {
                resolve();
            });
        });
    }
}

const ubisoftOverlayService = new UbisoftOverlayService();

export default ubisoftOverlayService;
